/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function(){
    let cartDrawerContent = document.querySelector('.shopify-section--mini-cart .drawer__content');
    if (Math.abs(cartDrawerContent.scrollHeight) > Math.abs(cartDrawerContent.clientHeight)){
      cartDrawerContent.previousSibling.classList.add('scrollable');
    }
    document.querySelector('.shopify-section--mini-cart .drawer__content').addEventListener('scroll', event => {
      const {scrollHeight, scrollTop, clientHeight} = event.target;
    
      if (Math.abs(scrollTop) > 10) {
        console.log('scrolled');
        event.target.previousSibling.classList.add('scrolled');
      } else {
        console.log('top');
        event.target.previousSibling.classList.remove('scrolled');
      }
      
      if (Math.abs(scrollHeight) > Math.abs(clientHeight)) {
        console.log('scrollable');
        event.target.previousSibling.classList.add('scrollable');
      }
      if (Math.abs(scrollTop + clientHeight) == scrollHeight){
        event.target.previousSibling.classList.remove('scrollable');
      }
  
      console.log(Math.abs(scrollTop),Math.abs(scrollHeight),Math.abs(clientHeight));
    });
  }, 5000);
  document.querySelector('.shopify-section--mini-cart .drawer__content').addEventListener('scroll', event => {
    const {scrollHeight, scrollTop, clientHeight} = event.target;
  
    if (Math.abs(scrollTop) > 10) {
      console.log('scrolled');
      event.target.previousSibling.classList.add('scrolled');
    } else {
      console.log('top');
      event.target.previousSibling.classList.remove('scrolled');
    }

    if (Math.abs(scrollHeight) > Math.abs(clientHeight)) {
      console.log('scrollable');
      event.target.previousSibling.classList.add('scrollable');
    }
    if (Math.abs(scrollTop + clientHeight) == scrollHeight){
      console.log('top');
      event.target.previousSibling.classList.remove('scrollable');
    }

    if (Math.abs(scrollTop + clientHeight) == scrollHeight) {
      console.log('bottom');
    }

    console.log(Math.abs(scrollTop),Math.abs(scrollHeight),Math.abs(clientHeight));
  });
});

document.addEventListener('cart:updated', function(event) {
  setTimeout(function(){
    upsellplusapp.init_drawer_offer();
    setTimeout(function(){
      let cartDrawerContent = document.querySelector('.shopify-section--mini-cart .drawer__content');
      if (Math.abs(cartDrawerContent.scrollHeight) > Math.abs(cartDrawerContent.clientHeight)){
        cartDrawerContent.previousSibling.classList.add('scrollable');
      }
      document.querySelector('.shopify-section--mini-cart .drawer__content').addEventListener('scroll', event => {
        const {scrollHeight, scrollTop, clientHeight} = event.target;
      
        if (Math.abs(scrollTop) > 10) {
          console.log('scrolled');
          event.target.previousSibling.classList.add('scrolled');
        } else {
          console.log('top');
          event.target.previousSibling.classList.remove('scrolled');
        }
        
        if (Math.abs(scrollHeight) > Math.abs(clientHeight)) {
          console.log('scrollable');
          event.target.previousSibling.classList.add('scrollable');
        }
        if (Math.abs(scrollTop + clientHeight) == scrollHeight){
          event.target.previousSibling.classList.remove('scrollable');
        }
    
        console.log(Math.abs(scrollTop),Math.abs(scrollHeight),Math.abs(clientHeight));
      });
    }, 500);
  }, 500);
  console.log('cart updated');
  document.querySelector('.shopify-section--mini-cart .drawer__content').addEventListener('scroll', event => {
    const {scrollHeight, scrollTop, clientHeight} = event.target;
  
    if (Math.abs(scrollTop) > 10) {
      console.log('scrolled');
      event.target.previousSibling.classList.add('scrolled');
    } else {
      console.log('top');
      event.target.previousSibling.classList.remove('scrolled');
    }
    
    if (Math.abs(scrollHeight) > Math.abs(clientHeight)) {
      console.log('scrollable');
      event.target.previousSibling.classList.add('scrollable');
    }
    if (Math.abs(scrollTop + clientHeight) == scrollHeight){
      event.target.previousSibling.classList.remove('scrollable');
    }

    console.log(Math.abs(scrollTop),Math.abs(scrollHeight),Math.abs(clientHeight));
  });
});

document.addEventListener('DOMContentLoaded', function(event) {
  let thumbnailButtons = document.querySelectorAll('.product__thumbnail-list-inner button');
  let activeThumbnailButtons = document.querySelectorAll('.product__thumbnail-list-inner button:not(.is-filtered)');
  if(thumbnailButtons) {
    thumbnailButtons.forEach(function(button, index) {
      button.removeAttribute('aria-label');
    });
  }
  if(activeThumbnailButtons) {
    let activeThumbnailButtonLength = activeThumbnailButtons.length;
    activeThumbnailButtons.forEach(function(button, index) {
      let buttonIndex = index + 1;
      button.setAttribute('aria-label', 'Image ' + buttonIndex + ' of ' + activeThumbnailButtonLength)
    });
  }
});
                          
document.addEventListener('variant:changed', function(event) {
  let thumbnailButtons = document.querySelectorAll('.product__thumbnail-list-inner button');
  let activeThumbnailButtons = document.querySelectorAll('.product__thumbnail-list-inner button:not(.is-filtered)');
  if(thumbnailButtons) {
    thumbnailButtons.forEach(function(button, index) {
      button.removeAttribute('aria-label');
    });
  }
  if(activeThumbnailButtons) {
    let activeThumbnailButtonLength = activeThumbnailButtons.length;
    activeThumbnailButtons.forEach(function(button, index) {
      let buttonIndex = index + 1;
      button.setAttribute('aria-label', 'Image ' + buttonIndex + ' of ' + activeThumbnailButtonLength)
    });
  }
});

new PerformanceObserver((entryList) => {
  for (const entry of entryList.getEntries()) {
    console.log('Layout shift:', entry);
  }
}).observe({type: 'layout-shift', buffered: true});

const navViewMoreButtons = document.querySelectorAll('.linklist__view-more');

for (const navViewMoreButton of navViewMoreButtons) {
  navViewMoreButton.addEventListener('click', () => {
    const siblings = navViewMoreButton.parentElement.children;
  
    for (const sibling of siblings) {
      sibling.classList.remove("linklist__item-hidden");
    }
    navViewMoreButton.classList.add("linklist__item-hidden");
    document.getElementById("linklist__item-view-more").focus({ focusVisible: true });
  });
}

const cartToggle = document.querySelector('[aria-controls="mini-cart"]');

cartToggle.addEventListener('click', () => {
  document.querySelector('.shopify-section--mini-cart .drawer__content').addEventListener('scroll', event => {
    const {scrollHeight, scrollTop, clientHeight} = event.target;
  
    if (Math.abs(scrollTop) > 10) {
      console.log('scrolled');
      event.target.previousSibling.classList.add('scrolled');
    } else {
      console.log('top');
      event.target.previousSibling.classList.remove('scrolled');
    }
    
    if (Math.abs(scrollHeight) > Math.abs(clientHeight)) {
      console.log('scrollable');
      event.target.previousSibling.classList.add('scrollable');
    }
    if (Math.abs(scrollTop + clientHeight) == scrollHeight) {
      event.target.previousSibling.classList.remove('scrollable');
    }

    console.log(Math.abs(scrollTop),Math.abs(scrollHeight),Math.abs(clientHeight));
  });
});

document.addEventListener("change", function(e){
  const target = e.target.closest(".product-item-upsell .select");

  if(target){
    const targetUpsell = e.target.closest(".product-item-upsell");
    const targetImage = target.options[target.selectedIndex].getAttribute('data-image');
    const targetPrice = target.options[target.selectedIndex].getAttribute('data-price');
    const targetComparePrice = target.options[target.selectedIndex].getAttribute('data-compare-at-price');
    
    const targetUpsellImage = targetUpsell.querySelector('.product-item__primary-image');
    const targetUpsellPrice = targetUpsell.querySelector('.price');
    const targetUpsellComparePrice = targetUpsell.querySelector('.price.price--compare');

    targetUpsellImage.setAttribute("srcset", '');
    targetUpsellImage.setAttribute("src", targetImage);
    targetUpsellPrice.innerText =targetPrice;
    targetUpsellComparePrice.innerText = targetComparePrice;
  }
});

const headerNavToggleLinks = document.querySelectorAll('desktop-navigation >ul > li > button');

for (const headerNavToggleLink of headerNavToggleLinks) {
  headerNavToggleLink.addEventListener('click', (event) => {
    if (headerNavToggleLink.classList.contains('nav-expanded')) {
      headerNavToggleLink.classList.remove('nav-expanded');
      headerNavToggleLink.setAttribute("aria-expanded", "false");
      var siblingNavToggleLink = headerNavToggleLink.nextElementSibling;
      console.log(siblingNavToggleLink);
      siblingNavToggleLink.setAttribute("hidden", "");
    } else {
      headerNavToggleLink.classList.add('nav-expanded');
      headerNavToggleLink.setAttribute("aria-expanded", "true");
      var siblingNavToggleLink = headerNavToggleLink.nextElementSibling;
      console.log(siblingNavToggleLink);
      siblingNavToggleLink.removeAttribute("hidden");
      siblingNavToggleLink.querySelector('a').focus({ focusVisible: true });
    }
    
  });
}

document.addEventListener("DOMContentLoaded", function(event) {
  var hash = window.location.hash;
  if(hash == "#product_reviews") {
    setTimeout(function() {
      const t = document.querySelector("#judgeme_product_reviews");
      t.scrollIntoView({
        block: "start",
        behavior: "smooth"
      });
    }, 1500); 
    setTimeout(function() {
      const t = document.querySelector("#judgeme_product_reviews");
      t.scrollIntoView({
        block: "start",
        behavior: "smooth"
      });
    }, 2000);
  }
  if(hash == "#judgeme_product_reviews") {
    setTimeout(function() {
      const t = document.querySelector("#judgeme_product_reviews");
      t.scrollIntoView({
        block: "start",
        behavior: "smooth"
      });
    }, 2000);   
  }
  if (hash == '#s-b74af899-4200-4f91-b9b7-de250c414128' || hash == '#s-3a2fed8c-f251-4cdd-be4d-5f72fd40e002') {
    setTimeout(function() {
      document.querySelector('#s-b74af899-4200-4f91-b9b7-de250c414128 .shogun-accordion-heading').click();
      document.querySelector('#s-3a2fed8c-f251-4cdd-be4d-5f72fd40e002 .shogun-accordion-heading').click();
      if (window.innerWidth < 768) {
        let = scrollElMobile = document.querySelector("#s-3a2fed8c-f251-4cdd-be4d-5f72fd40e002");
        scrollElMobile.scrollIntoView({
          block: "start",
          behavior: "smooth"
        });
      }      
    }, 200);
  }
  if (hash == '#s-dbc02791-350d-4edb-92a9-210b59eecc4b' || hash == '#s-f903ba70-6245-4f07-bb0c-0f70c3b0300d') {
    setTimeout(function() {
      document.querySelector('#s-dbc02791-350d-4edb-92a9-210b59eecc4b .shogun-accordion-heading').click();
      document.querySelector('#s-f903ba70-6245-4f07-bb0c-0f70c3b0300d .shogun-accordion-heading').click();
      if (window.innerWidth < 768) {
        let = scrollElMobile = document.querySelector("#s-f903ba70-6245-4f07-bb0c-0f70c3b0300d");
        scrollElMobile.scrollIntoView({
          block: "start",
          behavior: "smooth"
        });
      }    
    }, 200);
  }
  if (hash == '#s-59828925-2568-4e9b-bb8a-b1c394d33114' || hash == '#s-2b190d18-fcf5-4ba0-9507-61501471a4f1') {
    setTimeout(function() {
      document.querySelector('#s-59828925-2568-4e9b-bb8a-b1c394d33114 .shogun-accordion-heading').click();
      document.querySelector('#s-2b190d18-fcf5-4ba0-9507-61501471a4f1 .shogun-accordion-heading').click();
      if (window.innerWidth < 768) {
        let = scrollElMobile = document.querySelector("#s-2b190d18-fcf5-4ba0-9507-61501471a4f1");
        scrollElMobile.scrollIntoView({
          block: "start",
          behavior: "smooth"
        });
      }
    }, 200);
  }
  if (hash == '#s-19cb6f7b-5aef-42ca-aa35-f1a5aa0a346a' || hash == '#s-47e269ab-1d08-4f68-9c33-540bd6ef7a3b') {
    setTimeout(function() {
      document.querySelector('#s-19cb6f7b-5aef-42ca-aa35-f1a5aa0a346a .shogun-accordion-heading').click();
      document.querySelector('#s-47e269ab-1d08-4f68-9c33-540bd6ef7a3b .shogun-accordion-heading').click();
      if (window.innerWidth < 768) {
        let = scrollElMobile = document.querySelector("#s-47e269ab-1d08-4f68-9c33-540bd6ef7a3b");
        scrollElMobile.scrollIntoView({
          block: "start",
          behavior: "smooth"
        });
      }
    }, 200);
  }

  if (hash == '#s-4a60c36f-1e3c-4a05-ab0f-411706faac35' || hash == '#s-fc0db3fd-06ff-43a7-a562-534c094c7eb4') {
    setTimeout(function() {
      if (window.innerWidth < 768) {
        let = scrollEl = document.querySelector("#s-fc0db3fd-06ff-43a7-a562-534c094c7eb4");
        scrollEl.scrollIntoView({
          block: "start",
          behavior: "smooth"
        });
      } else {
        let = scrollEl = document.querySelector("#s-4a60c36f-1e3c-4a05-ab0f-411706faac35");
        scrollEl.scrollIntoView({
          block: "start",
          behavior: "smooth"
        });
      }
    }, 200);
  }

  if (hash == '#s-dc906870-a6f0-418f-9050-124344ef234c' || hash == '#s-88040a64-c34d-41c5-b004-3935e87fb91e') {
    setTimeout(function() {
      if (window.innerWidth < 768) {
        let = scrollEl = document.querySelector("#s-88040a64-c34d-41c5-b004-3935e87fb91e");
        scrollEl.scrollIntoView({
          block: "start",
          behavior: "smooth"
        });
      } else {
        let = scrollEl = document.querySelector("#s-dc906870-a6f0-418f-9050-124344ef234c");
        scrollEl.scrollIntoView({
          block: "start",
          behavior: "smooth"
        });
      }
    }, 200);
  }

  if (hash == '#s-bb123468-c332-46fa-ba4e-9948366a9f8b' || hash == '#s-90af5ca8-60b7-4b66-b58c-13cb76d638a7') {
    setTimeout(function() {
      if (window.innerWidth < 768) {
        let = scrollEl = document.querySelector("#s-90af5ca8-60b7-4b66-b58c-13cb76d638a7");
        scrollEl.scrollIntoView({
          block: "start",
          behavior: "smooth"
        });
      } else {
        let = scrollEl = document.querySelector("#s-bb123468-c332-46fa-ba4e-9948366a9f8b");
        scrollEl.scrollIntoView({
          block: "start",
          behavior: "smooth"
        });
      }
    }, 200);
  }

  if (hash == '#s-aeed7574-61ad-44d1-8f31-686c88e84234' || hash == '#s-f7f2f62a-d631-4b43-8dc1-6fb986921dcd') {
    setTimeout(function() {
      if (window.innerWidth < 768) {
        let = scrollEl = document.querySelector("#s-f7f2f62a-d631-4b43-8dc1-6fb986921dcd");
        scrollEl.scrollIntoView({
          block: "start",
          behavior: "smooth"
        });
      } else {
        let = scrollEl = document.querySelector("#s-aeed7574-61ad-44d1-8f31-686c88e84234");
        scrollEl.scrollIntoView({
          block: "start",
          behavior: "smooth"
        });
      }
    }, 200);
  }
  
});

const supportLink1 = document.querySelector('.footer__item--links a[href*="#s-4a60c36f-1e3c-4a05-ab0f-411706faac35"]');
const supportLink2 = document.querySelector('.footer__item--links a[href*="#s-dc906870-a6f0-418f-9050-124344ef234c"]');
const supportLink3 = document.querySelector('.footer__item--links a[href*="#s-bb123468-c332-46fa-ba4e-9948366a9f8b"]');
const supportLink4 = document.querySelector('.footer__item--links a[href*="#s-aeed7574-61ad-44d1-8f31-686c88e84234"]');

if (window.innerWidth < 768 && window.location.href.indexOf("pages/customer-support") != -1) {
  window.addEventListener('hashchange', function(event) {
    var hash = window.location.hash;
    if (hash == '#s-4a60c36f-1e3c-4a05-ab0f-411706faac35' || hash == '#s-fc0db3fd-06ff-43a7-a562-534c094c7eb4') {
      setTimeout(function() {
        if (window.innerWidth < 768) {
          let = scrollEl = document.querySelector("#s-fc0db3fd-06ff-43a7-a562-534c094c7eb4");
          scrollEl.scrollIntoView({
            block: "start",
            behavior: "smooth"
          });
        } else {
          let = scrollEl = document.querySelector("#s-4a60c36f-1e3c-4a05-ab0f-411706faac35");
          scrollEl.scrollIntoView({
            block: "start",
            behavior: "smooth"
          });
        }
      }, 200);
    }
  
    if (hash == '#s-dc906870-a6f0-418f-9050-124344ef234c' || hash == '#s-88040a64-c34d-41c5-b004-3935e87fb91e') {
      setTimeout(function() {
        if (window.innerWidth < 768) {
          let = scrollEl = document.querySelector("#s-88040a64-c34d-41c5-b004-3935e87fb91e");
          scrollEl.scrollIntoView({
            block: "start",
            behavior: "smooth"
          });
        } else {
          let = scrollEl = document.querySelector("#s-dc906870-a6f0-418f-9050-124344ef234c");
          scrollEl.scrollIntoView({
            block: "start",
            behavior: "smooth"
          });
        }
      }, 200);
    }
  
    if (hash == '#s-bb123468-c332-46fa-ba4e-9948366a9f8b' || hash == '#s-90af5ca8-60b7-4b66-b58c-13cb76d638a7') {
      setTimeout(function() {
        if (window.innerWidth < 768) {
          let = scrollEl = document.querySelector("#s-90af5ca8-60b7-4b66-b58c-13cb76d638a7");
          scrollEl.scrollIntoView({
            block: "start",
            behavior: "smooth"
          });
        } else {
          let = scrollEl = document.querySelector("#s-bb123468-c332-46fa-ba4e-9948366a9f8b");
          scrollEl.scrollIntoView({
            block: "start",
            behavior: "smooth"
          });
        }
      }, 200);
    }
  
    if (hash == '#s-aeed7574-61ad-44d1-8f31-686c88e84234' || hash == '#s-f7f2f62a-d631-4b43-8dc1-6fb986921dcd') {
      setTimeout(function() {
        if (window.innerWidth < 768) {
          let = scrollEl = document.querySelector("#s-f7f2f62a-d631-4b43-8dc1-6fb986921dcd");
          scrollEl.scrollIntoView({
            block: "start",
            behavior: "smooth"
          });
        } else {
          let = scrollEl = document.querySelector("#s-aeed7574-61ad-44d1-8f31-686c88e84234");
          scrollEl.scrollIntoView({
            block: "start",
            behavior: "smooth"
          });
        }
      }, 200);
    }
  });
}

const colorToggleLinks = document.querySelectorAll('.product-item-meta__swatch-list .color-swatch__item');

for (const colorToggleLink of colorToggleLinks) {
  colorToggleLink.addEventListener('click', (event) => {
    var productItem = event.target.closest('product-item');                   
    var variantPrice = event.target.previousElementSibling.getAttribute("data-variant-price");
    var variantComparePrice = event.target.previousElementSibling.getAttribute("data-variant-compare-price");
    var variantFullPrice = event.target.previousElementSibling.getAttribute("data-variant-full-price");
    if (variantFullPrice == "true") {
      productItem.classList.remove("product-sale");
      productItem.classList.add("product-full-price");
    } else {
      productItem.classList.remove("product-full-price");
      productItem.classList.add("product-sale");
    }
    productItem.querySelector('.price-list .price').innerHTML = variantPrice;
    productItem.querySelector('.price-list .price--compare').innerHTML = variantComparePrice;
  });
}

document.addEventListener("DOMContentLoaded", function(event) {
  let collectionSubNavigation = document.querySelector('.shopify-section--collection-sub-navigation');
  
  if(collectionSubNavigation) {
    if(collectionSubNavigation.querySelector('scrollable-content').scrollLeft != 0) {
      collectionSubNavigation.querySelector('prev-next-buttons button').removeAttribute("disabled");
    }
  }
});

window._AutofillCallbackHandler = window._AutofillCallbackHandler || function(){}
